// @flow
import * as React from 'react';
import { DropTarget } from 'react-dnd';
import DragItemTypes from 'app/common/react/components/DragDrop/DraggableItem';
import withDragDropContext from 'app/common/lib/react/withDragDropContext';
import { compose } from 'redux';

const withDragDropSurface = (type: $Values<typeof DragItemTypes>) => (
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  component: React.ComponentType<*>,
) =>
  compose(
    withDragDropContext,
    DropTarget(type, {}, (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isDragWithinBounds: monitor.isOver(),
    })),
  )(component);
export default withDragDropSurface;
